module.exports = __webpack_public_path__ + "static/media/Lakshmi Sajilal - no background.6d1f63bf.png";